import css from 'styled-jsx/css';

export default css`.right-content {
    .top-switch-icon {
        width: 100%;
        height: 60px;
        text-align: right;
        img {
            width: 60px;
            height: 100%;
            cursor: pointer;
        }
    }
    :global(.login-title) {
        height: 25px;
        font-size: 18px;
        font-weight: 500;
        color: #000000;
        line-height: 25px;
        text-align: center;
    }
    .login-bottom-switch {
        margin-top: 16px;
        text-align: center;
        color: #999;
        font-size: 12px;
        span {
            color: #FF6400;
            cursor: pointer;
        }
    }
}`